import { useCallback, useState } from "react";

export const useToggle = (initial = false) => {
    const [value, setValue] = useState(initial);
    const toggle = useCallback(() => setValue(t => !t), [setValue]);
    return [value, toggle] as const;
};
